
interface UseInputHandlersProps {
  pricePerUnitRange: { min: number; max: number };
  costPerUnitRange: { min: number; max: number };
  orderVolumeRange: { min: number; max: number };
  setPricePerUnit: (value: number) => void;
  setDiscountRate: (value: number) => void;
  setCostPerUnit: (value: number) => void;
  setOrderVolume: (value: number) => void;
  setPriceInputValue: (value: string) => void;
  setDiscountInputValue: (value: string) => void;
  setCostInputValue: (value: string) => void;
  setVolumeInputValue: (value: string) => void;
  setCostPerUnitRange: (range: { min: number; max: number }) => void;
  setIsVolumeManuallyAdjusted: (value: boolean) => void;
}

export const useInputHandlers = (props: UseInputHandlersProps) => {
  const handlePriceInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[$,]/g, '');
    props.setPriceInputValue(value);
    const numValue = parseFloat(value);
    if (!isNaN(numValue) && numValue >= props.pricePerUnitRange.min && numValue <= props.pricePerUnitRange.max) {
      props.setPricePerUnit(numValue);
    }
  };

  const handleDiscountInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/%/g, '');
    props.setDiscountInputValue(value);
    const numValue = parseFloat(value);
    if (!isNaN(numValue) && numValue >= 0 && numValue <= 90) {
      props.setDiscountRate(numValue);
    }
  };

  const handleCostInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[$,]/g, '');
    props.setCostInputValue(value);
    const numValue = parseFloat(value);

    if (!isNaN(numValue)) {
      const buffer = numValue * 0.5;
      const newMin = Math.max(1, numValue - buffer);
      const newMax = numValue + buffer;

      props.setCostPerUnit(numValue);
      props.setCostPerUnitRange({
        min: newMin,
        max: newMax
      });
    }
  };

  const handleVolumeInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[$,]/g, '');
    props.setVolumeInputValue(value);
    const numValue = parseFloat(value);
    
    if (!isNaN(numValue) && numValue >= props.orderVolumeRange.min && numValue <= props.orderVolumeRange.max) {
      props.setIsVolumeManuallyAdjusted(true);
      props.setOrderVolume(numValue);
    }
  };

  return {
    handlePriceInputChange,
    handleDiscountInputChange,
    handleCostInputChange,
    handleVolumeInputChange
  };
};
